import * as React from "react"
import {bgStyleBlue,fontFaceBarlow} from './shared.module.scss'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import {graphql,useStaticQuery} from 'gatsby'

const Benefits = ()=>{
  const data = useStaticQuery(graphql`
    query {
        contentfulCorporate {
            benefits
             benefitsImage {
              gatsbyImageData
            }
      }
    }
    `
  )

    const image = getImage(data.contentfulCorporate.benefitsImage)
    return(
        <section className={bgStyleBlue}>
        <br />
        <br />
            <div className=" container" style={{marginTop:'2rem', marginBottom:'2rem'}}>
                <div className="columns is-mobile is-multiline">
                    <div className="column is-full-mobile ">
                        <h1 className={fontFaceBarlow+" is-size-2"} style={{lineHeight:'43px'}}>Benefits of Living at a McKinley Community</h1>
                        <br />
                        <ul style={{listStyle:'disc',marginLeft:'2rem'}}>
                        {data.contentfulCorporate.benefits.map((b, index)=>(
                            <li key={index}>{b}</li>
                        ))}
                        </ul>
                        <br />
                        <br />
                    </div>
                    <div className="column is-full-mobile">
                        <GatsbyImage image={image} alt="" />
                    </div>
                </div>
            </div>
        <br />
        <br />
        </section>
    )
}


export default Benefits
